import React, { PropTypes } from 'react';
import MatchHydrate from './match-hydrate.js';
import GameLoader from './game-loader.js';

const Game = (props) => {
	const authenticate = props.match.params.gameMode.toUpperCase() === 'REAL';
	return (
		<div id="game">
			<MatchHydrate authenticate={authenticate} path="/casino/game/:gameCode/:gameMode" component={GameLoader} />
		</div>
	);
};

Game.propTypes = {
	params: PropTypes.object
};

export default Game;



// WEBPACK FOOTER //
// ./mobile-core/src/components/game.js